// extracted by mini-css-extract-plugin
module.exports = {"userCard":"_4U5ZJd9","userCardHeader":"JvmUMQi","charIcon":"SzQ_Ltr","userCardHeaderDetails":"EKtSgoJ","userAboutCard":"qqMz_MU"};